import { render, staticRenderFns } from "./select-table-data.vue?vue&type=template&id=8ef58782&"
import script from "./select-table-data.vue?vue&type=script&lang=ts&"
export * from "./select-table-data.vue?vue&type=script&lang=ts&"
import style0 from "./select-table-data.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports